import type { ProgramInviteType } from 'models';
import type { FormInstance } from 'ui';
import type { EmailSelectedUser, RegisteredSelectedUser } from '../../../../types';
import type { InviteesType } from '../../../EventInvitees';
import CommunitiesEventInviteesPicker from './CommunitiesEventInviteesPicker';
import type { CommonFormValues } from './hooks';
import ProgramEventInviteesPicker from './ProgramEventInviteesPicker';

type P = {
  allowedInvites?: InviteesType[];
  communityId?: string;
  form: FormInstance<CommonFormValues>;
  inviteType: ProgramInviteType;
  onBack?: () => void;
  onInvite: (
    inviteType: ProgramInviteType,
    invitees: RegisteredSelectedUser[],
    emailInvitees?: EmailSelectedUser[],
  ) => void;
  programId?: string;
  // TODO this should be type
  role?: 'admin' | 'member';
};

const EventInviteesPicker = ({ communityId, programId, ...rest }: P) => {
  if (programId) {
    return <ProgramEventInviteesPicker programId={programId} {...rest} />;
  }

  if (communityId) {
    return <CommunitiesEventInviteesPicker communityId={communityId} {...rest} />;
  }

  return null;
};

export default EventInviteesPicker;
